import { Snackbar } from '@carrier-io/air-react';
import { useNotification } from 'context/NotificationContext';

const Notification = () => {
  const {
    isNotificationOpened,
    textContent,
    notificationBgColor,
    autoHideDuration,
    transitionDuration,
    anchorOriginConfig,
    setIsNotificationOpened,
  } = useNotification();

  return (
    <Snackbar
      data-testid="notification"
      anchorOrigin={anchorOriginConfig}
      sx={{
        '.MuiSnackbarContent-root': {
          backgroundColor: notificationBgColor,
        },
      }}
      message={textContent}
      onClose={() => {
        setIsNotificationOpened(false);
      }}
      open={isNotificationOpened}
      autoHideDuration={autoHideDuration}
      transitionDuration={transitionDuration}
    />
  );
};

export default Notification;
